import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzSmdBl } from './pages'

type TIdToPageMapWoofzSmdBl = Record<PageIdWoofzSmdBl, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_SMD_BL: TIdToPageMapWoofzSmdBl = {
  [PageIdWoofzSmdBl.DOG_AGE_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/DogAge').then((m) => ({
        default: m.DogAge,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_smd_bl/pages/questions/DogAge'),
  },
  [PageIdWoofzSmdBl.DOG_SEX_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/SexQuestion').then(
        (m) => ({
          default: m.SexQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/SexQuestion'),
  },
  [PageIdWoofzSmdBl.DOG_BREED_SMD_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_smd_bl/pages/questions/dog-breed/DogBreedQuestion'
      ).then((m) => ({
        default: m.DogBreedQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_smd_bl/pages/questions/dog-breed/DogBreedQuestion'
      ),
  },
  [PageIdWoofzSmdBl.URGE_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_smd_bl/pages/urge/UrgePage'),
  },
  [PageIdWoofzSmdBl.GOALS_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/GoalsQuestion').then(
        (m) => ({
          default: m.GoalsQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/GoalsQuestion'),
  },
  [PageIdWoofzSmdBl.URGE_1_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/urge/Urge1Page').then((m) => ({
        default: m.Urge1Page,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_smd_bl/pages/urge/Urge1Page'),
  },
  [PageIdWoofzSmdBl.AGRESSIVE_BEHAVIOR_SMD_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_smd_bl/pages/questions/AgressiveBehavior'
      ).then((m) => ({
        default: m.AgressiveBehavior,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/AgressiveBehavior'),
  },
  [PageIdWoofzSmdBl.TRIGGERS_SMD_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_smd_bl/pages/questions/TriggersQuestion'
      ).then((m) => ({
        default: m.TriggersQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/TriggersQuestion'),
  },
  [PageIdWoofzSmdBl.URGE_2_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/urge/UrgePageVariant2'),
  },
  [PageIdWoofzSmdBl.BEHAVIOR_ISSUES_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/BehaviorIssues').then(
        (m) => ({
          default: m.BehaviorIssues,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/BehaviorIssues'),
  },
  [PageIdWoofzSmdBl.DOG_LISTEN_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/DogListen').then(
        (m) => ({
          default: m.DogListen,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/DogListen'),
  },
  [PageIdWoofzSmdBl.COMMANDS_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/DogCues').then(
        (m) => ({
          default: m.DogCues,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_smd_bl/pages/questions/DogCues'),
  },
  [PageIdWoofzSmdBl.EAT_OFF_THE_GROUND_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/EatOffTheGround').then(
        (m) => ({
          default: m.EatOffTheGround,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/EatOffTheGround'),
  },
  [PageIdWoofzSmdBl.DOG_ACT_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/DogActQuestion').then(
        (m) => ({
          default: m.DogActQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/DogActQuestion'),
  },
  [PageIdWoofzSmdBl.DOG_OFF_AT_HOME_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/DogOffAtHome').then(
        (m) => ({
          default: m.DogOffAtHome,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/DogOffAtHome'),
  },
  [PageIdWoofzSmdBl.PREPARE_SCREEN_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/urge/UrgePrepareScreen').then(
        (m) => ({
          default: m.UrgePrepareScreen,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/urge/UrgePrepareScreen'),
  },
  [PageIdWoofzSmdBl.DOG_PROFILE_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/dog-profile/DogProfile').then(
        (m) => ({
          default: m.DogProfile,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/dog-profile/DogProfile'),
  },
  [PageIdWoofzSmdBl.HEAR_ABOUT_WOOFZ_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/HearAboutWoofz').then(
        (m) => ({
          default: m.HearAboutWoofz,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/HearAboutWoofz'),
  },
  [PageIdWoofzSmdBl.MANNERS_TO_BUILD_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/MannersToBuild').then(
        (m) => ({
          default: m.MannersToBuild,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/MannersToBuild'),
  },
  [PageIdWoofzSmdBl.FEEL_BETTER_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/FeelBetter').then(
        (m) => ({
          default: m.FeelBetter,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/questions/FeelBetter'),
  },
  [PageIdWoofzSmdBl.PREPARE_FLOW_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/prepare-flow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/prepare-flow/PrepareFlow'),
  },
  [PageIdWoofzSmdBl.EMAIL_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_smd_bl/pages/email/Email'),
  },
  [PageIdWoofzSmdBl.NEWSLETTER_URGE_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/email/NewsletterUrge').then(
        (m) => ({
          default: m.NewsletterUrge,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/email/NewsletterUrge'),
  },
  [PageIdWoofzSmdBl.SCRATCH_SCREEN_SMD_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_smd_bl/pages/last-chance-offer/LastChanceOfferScratch'
      ).then((m) => ({
        default: m.LastChanceOfferScratch,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_smd_bl/pages/last-chance-offer/LastChanceOfferScratch'
      ),
  },
  [PageIdWoofzSmdBl.SUBSCRIPTIONS_SMD_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_smd_bl/pages/subscriptions/Subscriptions'
      ).then((m) => ({
        default: m.Subscriptions,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/subscriptions/Subscriptions'),
  },
  [PageIdWoofzSmdBl.CHAT_UPSELL_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/upsell/ChatUpsellNewFlow'),
  },
  [PageIdWoofzSmdBl.UPSELL_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_smd_bl/pages/upsell/Upsell'),
  },
  [PageIdWoofzSmdBl.UPSELL_FEEDING_GUIDE_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/upsell/FeedingGuideUpsell').then(
        (m) => ({
          default: m.FeedingGuideUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/upsell/FeedingGuideUpsell'),
  },
  [PageIdWoofzSmdBl.UPSELL_EMOTIONAL_SUPPORT_SMD_BL]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_smd_bl/pages/upsell/EmotionalSupportUpsell'
      ).then((m) => ({
        default: m.EmotionalSupportUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/upsell/EmotionalSupportUpsell'),
  },
  [PageIdWoofzSmdBl.DOWNLOAD_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/pages/download-app/DownloadApp'),
  },
  [PageIdWoofzSmdBl.ACCOUNT_SMD_BL]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_smd_bl/modules/account/AccountSmd').then(
        (m) => ({
          default: m.AccountSmd,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_smd_bl/modules/account/AccountSmd'),
  },
}
